import { supabase } from './supabaseClient'

// Map a MediaRecorder blob mime to a file extension the bucket + an
// <audio> element are both happy with.
function extFor(mime) {
  if (mime.includes('webm')) return 'webm'
  if (mime.includes('mp4')) return 'm4a'
  if (mime.includes('mpeg')) return 'mp3'
  if (mime.includes('ogg')) return 'ogg'
  if (mime.includes('aac')) return 'aac'
  if (mime.includes('wav')) return 'wav'
  return 'webm'
}

// Upload a recorded voice note for the sender. Strips the codecs
// suffix off the blob mime (the storage allow-list matches the base
// type only) and writes to message-audio/<senderId>/<uuid>.<ext>.
// Resolves { url, error }.
export async function uploadMessageAudio(senderId, blob) {
  if (!senderId) return { url: null, error: 'missing senderId' }
  if (!blob) return { url: null, error: 'missing blob' }

  const baseMime = (blob.type || 'audio/webm').split(';')[0]
  const ext = extFor(baseMime)
  const id = (crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`
  const path = `${senderId}/${id}.${ext}`

  const { error: uploadError } = await supabase.storage
    .from('message-audio')
    .upload(path, blob, { upsert: false, contentType: baseMime, cacheControl: '3600' })
  if (uploadError) return { url: null, error: uploadError.message }

  const { data: pub } = supabase.storage.from('message-audio').getPublicUrl(path)
  if (!pub?.publicUrl) return { url: null, error: 'no publicUrl returned' }
  return { url: pub.publicUrl, error: null }
}
